
export default {
  name: "LegacyPrintOptions",
  props: {
    value: {
      type: Object,
      required: true,
    },
    customText: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      optionsList: [
        { key: "cod_barras", label: "Gerar código de barra" },
        { key: "preco", label: "Gerar preço de venda" },
        { key: "imprimir_logo", label: "Impressão da logo" },
        { key: "considerar_referencia", label: "Considerar referência" },
        {
          key: "considerar_codigo_interno",
          label: "Considerar código interno",
        },
        {
          key: "codigo_interno_somente_numeracao",
          label: "Utilizar somente numeração (código interno)",
          subordinate: true,
          requiresInternalCode: true,
        },
        { key: "valor_por_kg", label: "Gerar valor por KG" },
      ],
    };
  },
  methods: {
    isDisabled(option) {
      return Boolean(
        option.requiresInternalCode && !this.value.considerar_codigo_interno
      );
    },
  },
};
